import { render, staticRenderFns } from "./menu-wrap.vue?vue&type=template&id=c74bc78c&scoped=true&"
import script from "./menu-wrap.vue?vue&type=script&lang=js&"
export * from "./menu-wrap.vue?vue&type=script&lang=js&"
import style0 from "./menu-wrap.vue?vue&type=style&index=0&id=c74bc78c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c74bc78c",
  null
  
)

export default component.exports